<template>
    <div class="media imei-item" v-if="isReady && (isPhone || isValidTablet)">
        <div class="media-left d-none d-md-block">
            <img :src="device.device.image_path" alt="Device Image" class="img-2x" />
        </div>
        <div class="media-body flex-column">
            <h5>{{ device.device.title }}</h5>
            <p class="text-sm">
                <strong>{{$t('bp.ImeiItem.repairs')}}</strong> <span v-for="(detail, index) in device.problems" :key="index"><span v-if="index > 0">, </span>{{ detail.title }}</span>
            </p>
            <div class="form-group" v-if="!imeiSupplied">
                <div class="input-group">
                    <input class="form-control form-control-md mb-0" :placeholder="(isValidTablet) ? $t('bp.ImeiItem.placeholder.serial') : $t('bp.ImeiItem.placeholder.imei')" :disabled="checkingImei" v-model="imei">
                    <span class="input-group-btn">
                        <button class="btn btn-success" v-if="!checkingImei" @click="storeImei()">{{$t('bp.ImeiItem.button.add')}}</button>
                        <button class="btn btn-success" v-if="checkingImei" disabled><animated-loading class="mr-2" size="xs"></animated-loading>{{$t('bp.ImeiItem.loading.checking')}}{{ (isValidTablet) ? $t('bp.ImeiItem.placeholder.serial') : $t('bp.ImeiItem.placeholder.imei') }}</button>
                    </span>
                </div>

                <div class="alert alert-danger mt-2" v-if="errors[0]">
                    <div class="alert-content text-sm">
                        * {{ errors[0] }}
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center" v-if="imeiSupplied">
                <animated-success class="mr-2 mb-1 d-inline-block" size="xs"></animated-success><strong>{{ (isValidTablet) ? $t('bp.ImeiItem.serial') : $t('bp.ImeiItem.imei') }}:</strong> {{ imei }}
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

    export default {
        props: ["device"],

        data() {
            return {
                checkingImei: false,
                errors: [],
                imei: "",
                imeiSupplied: false
            }
        },

        computed: {
            ...mapGetters(["emailAddress"]),
            isReady() {
                return (this.device && this.device.device);
            },

            /** Check if the device is a phone */
            isPhone() {
                return (this.device.device.device_type === "phone");
            },

            /** Check if the tablet is valid (Samsung) */
            isValidTablet() {
                return (this.device.device.device_type === "tablet" && this.device.device_make === "samsung");
            },
        },

        methods: {
            ...mapActions([
                "storeDeviceImei",
            ]),

            /** Store the IMEI */
            storeImei() {
                this.errors = [];
                this.checkingImei = true;
                this.storeDeviceImei({
                    deviceId: this.device.device.id,
                    email: this.emailAddress,
                    imei: this.imei
                }).then(() => {
                    this.checkingImei = false;
                    this.imeiSupplied = true;
                }).catch(error => {
                    if (error.response.data.messages.imei) {
                        this.errors = error.response.data.messages.imei;
                    } else {
                        this.errors = error.response.data.messages;
                    }
                    this.checkingImei = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>